function mapByField(collection, field) {
  return collection.reduce((acc, item) => {
    acc[item[field]] = item;
    return acc;
  }, {});
}
function mapById(collection) {
  return mapByField(collection, "id");
}
export {
  mapByField,
  mapById
};
//# sourceMappingURL=map-by-field.js.map
